export const CAROUSEL_ID = '#files_gallery-carousel';
export const MODAL_ID = '#files_gallery-modal';

const manageControls = (slide) => {
  const controls = $('.carousel-control');
  const videoElement = $(slide).find('video');
  if (videoElement.length) {
    controls.css('bottom', '50px');
    controls.css('top', '50px');
    $('.carousel-indicators').css('bottom', '40px');
  } else {
    controls.css('bottom', '0');
    controls.css('top', '0');
    $('.carousel-indicators').css('bottom', '10px');
  }
};

const showHideCarouselControls = () => {
  if ($(MODAL_ID).find('div.carousel-inner').find('div.item').length > 1) {
    $(CAROUSEL_ID).find('a.carousel-control').show();
  } else {
    $(CAROUSEL_ID).find('a.carousel-control').hide();
  }
};

const setFileTitleAndLoadData = () => {
  const baseModal = $(MODAL_ID);
  const activeDiv = baseModal.find('div.carousel-inner div.active');
  const dataSrc = activeDiv.find('[data-src]');
  if (dataSrc) {
    if (dataSrc.prop('tagName') === 'VIDEO') {
      dataSrc.append($('<source>').attr('src', dataSrc.data('src')));
    } else {
      dataSrc.attr('src', dataSrc.data('src'));
      // Hide loading gif when image is loaded.
      dataSrc.on('load', () => {
        dataSrc.parent().css('background-image', 'none');
      });
    }
    dataSrc.removeAttr('data-src');
  }

  baseModal.find('h4.modal-title').text(activeDiv.data('title') || '');
  baseModal.find('.modal-file-description').text(activeDiv.data('description') || '');
};

const resizeGalleryModal = () => {
  const baseModal = document.querySelector(MODAL_ID);
  if (!baseModal) {
    return;
  }
  const height = window.innerHeight - 180;
  const width = window.innerWidth - 100;
  baseModal.querySelectorAll('div.carousel-container').forEach(element => {
    element.style.height = `${height}px`;
    element.style.width = `${width}px`;
  });
  baseModal.querySelectorAll('div.carousel-container div.item').forEach(element => {
    element.style.height = `${height}px`;
    element.style.width = `${width}px`;
    const video = element.querySelector('video');
    if (video) {
      video.style.height = `${height - 20}px`;
    }
  });
};
export const appendFileToModal = (fileId, link, isVideo, title, description) => {
  const baseModal = $(MODAL_ID);
  if (baseModal.find(`li[data-file-id="${fileId}"]`).length) {
    return;
  }

  // Append indicator.
  const childrenLength = baseModal.find('ol.carousel-indicators li').length;
  baseModal.find('ol.carousel-indicators').append($(`<li data-target="${CAROUSEL_ID}" data-slide-to="${childrenLength}" data-file-id="${fileId}" ></li>`));
  // Append image (or video) to carrousel.
  const item = isVideo ? `<figure><video class="img-responsive" data-src="${link}" controls></video></figure>` : `<img data-src="${link}" class="img-responsive">`;
  baseModal.find('div.carousel-inner').append(`<div data-file-id="${fileId}" data-title="${title}" data-description="${description}" class="item">${item}</div>`);
  showHideCarouselControls();
};

const showModal = (event) => {
  const baseModal = $(MODAL_ID);

  const rowId = event.currentTarget?.getAttribute('data-file-id');
  if (!rowId) {
    return;
  }
  baseModal.find('ol.carousel-indicators li').removeClass('active');
  baseModal.find('div.carousel-inner div[data-file-id]').removeClass('active');
  baseModal.find(`ol.carousel-indicators li[data-file-id="${rowId}"]`).addClass('active');
  baseModal.find(`div.carousel-inner div[data-file-id="${rowId}"]`).addClass('active');
  setFileTitleAndLoadData();
  manageControls($('div.carousel-inner .active'));
  resizeGalleryModal();

  $(CAROUSEL_ID).carousel({
    interval: false,
  }).on('slid.bs.carousel', (event) => {
    setFileTitleAndLoadData();
    manageControls(event.relatedTarget);
    $(CAROUSEL_ID).find('video').each((index, element) => {
      element.pause();
    });
    $('a.right.carousel-control').focus();
  });
  baseModal.modal('show');
  // Focus the carousel controls, so that we can immediately use the left/right keys.
  baseModal.on('shown.bs.modal', () => {
    $('a.right.carousel-control').focus();
  });
};


/**
* Set up the modal display mechanism:
* 1 - When a new xhr query is emitted by datatables (ordering, paging,...), all the modal content is cleaned.
* 2 - When the datatables ends its rendering: set up the modal.
*/
export const prepareModalDisplay = () => {
  const baseModal = $(MODAL_ID);

  baseModal.find('ol.carousel-indicators li').remove();
  baseModal.find('div.carousel-inner div').remove();

  $('#patient-files-list').on('preXhr.dt', () => {
    // Clean up the carousel when a new request to fetch data is emitted.
    baseModal.find('ol.carousel-indicators li').remove();
    baseModal.find('div.carousel-inner div').remove();
  });

  document.querySelectorAll('a.file-gallery').forEach(galleryLink => {
    const description = galleryLink.getAttribute('data-description');
    const fileId = galleryLink.getAttribute('data-file-id');
    const isVideo = galleryLink.getAttribute('data-file-type') === 'video';
    const link = galleryLink.getAttribute('data-src');
    const title = galleryLink.getAttribute('data-title');

    appendFileToModal(fileId, link, isVideo, title, description);
  });
};

$(prepareModalDisplay);
$(document).on('pjax:end', () => {
  prepareModalDisplay();
});
$(document).on('click', 'a.file-gallery', showModal);
window.addEventListener('resize', resizeGalleryModal);
